<template>
  <v-row class="py-12 bg-image" :style="bgPrincipal">
    <v-col cols="12" class="d-flex justify-center align-center flex-column">
      <h1 class="white--text font-weight-medium" style="z-index: 2">
        SOMOS LA VENTAJA QUE BUSCAS
      </h1>
      <h3 class="white--text" style="z-index: 2">
        25 años y más de 35 campus en todo el país nos respaldan
      </h3>
      <router-link
        to="/informes"
        style="text-decoration: none; padding-bottom: 10px"
      >
        <v-btn
          depressed
          rounded
          light
          outlined
          color="white"
          lg
          class="my-4"
          style="z-index: 2"
        >
          Infórmate
        </v-btn>
      </router-link>
    </v-col>
  </v-row>
</template>
<style lang="scss" scoped>
ul {
  list-style: none;
}
.v-btn_center {
  text-align: center;
}
.rounded-circle {
  min-width: 2rem !important;
  min-height: 2rem !important;
  max-width: 2rem !important;
  max-height: 2rem !important;
  border-radius: 50%;
  margin-left: auto;
}
.bg-image {
  background-position: center;
  background-size: cover;
  height: 50vh;
  position: relative;
}
.bg-image::after {
  background-color: #1976d2;
  bottom: 0;
  content: "";
  left: 0;
  opacity: 0.5;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 1;
}
</style>
<script>
import { mask } from "vue-the-mask";
export default {
  directives: {
    mask,
  },
  props: ["btn_link", "grado", "logo", "image"],
  computed: {
    bgPrincipal() {
      return {
        "background-image": "url('" + this.image + "')",
      };
    },
  },
  data: () => ({
    msg: "",
    snackbarColor: "",
    snackbarText: "",
    snackbar: false,
    dateValid: false,
    emailValid: false,
    phoneValid: false,
    valid: false,
    publicPath: process.env.BASE_URL,
    dialogInformes: false,
    dialog: false,
    information: {
      name_first: "",
      name_second: "",
      last_name: "",
      mother_last_name: "",
      email: "",
      phone: "",
    },
  }),
};
</script>
